import Button from "../../components/Button";
import { useNavigate } from "react-router-dom";

function Success() {
    const navigate = useNavigate();

    return (<div className="flex flex-col justify-center items-center mt-[60px]">
        <h1 className="font-bold text-secondary text-[30px] mb-[40px]">🎉 Tài khoản của bạn đã đăng ký thành công! </h1>
        <Button label="Quay lại trang chủ" styleButton="w-[200px]" onClick={() => navigate("/")} />
    </div>);
}

export default Success;